import React, { useEffect, useState } from "react";
import IntlMessages from "util/IntlMessages";
import {
  Modal,
  Card,
  Table,
  Row,
  Col,
  Button,
  Tooltip,
  Input,
  Form,
  Spin,
  Tabs,
  Drawer,
  Descriptions,
  Select,
  Space,
  DatePicker
} from "antd";

import { useSelector, useDispatch } from "react-redux";
import {
  useGetPartnerInvoiceDataQuery,
  useGetPartnerTaxInvoiceDataQuery,
  useDownloadInvoiceDocumentMutation,
  useSendInvoiceReminderMutation,
  useGetPartnerInvoiceFiltersQuery,
  useGetPartnerTaxInvoiceFiltersQuery
} from "../../../appRedux/api/partnerInvoiceApi";
import { useGetPartnerListQuery } from "../../../appRedux/api/adminPartnerApi";
import {
  EditOutlined,
  UploadOutlined,
  EyeTwoTone,
  InfoCircleTwoTone,
  DownloadOutlined,
  BellOutlined,
  CloseOutlined,
  CheckOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  WarningOutlined,
  LeftOutlined,
  MedicineBoxOutlined,
} from "@ant-design/icons";
import { getRole, getUserInfo, getIsApprover } from "../../../helpers";
import moment from "moment";
import { royaltyInvoiceStatus } from "../../../constants";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import { useNavigate } from "react-router-dom";
import { editRoyaltyInvoiceRequestData, editTaxInvoiceRequest } from "../../../appRedux/actions";
import CustomPagination from "../../../components/CustomPagination";
import "./style.css";
import LoadingBar from "../../../components/LoadingBar";
import infoIcon from "assets/images/icons/info.svg";
import eyeIcon from "assets/images/icons/visibility.svg";
import notificationBellIcon from "assets/images/icons/notification.svg";
import deleteTempIcon from "assets/images/icons/delete.svg";
import editIcon from "assets/images/icons/Edit.svg";
import LicensorAddTaxDocumentModal from "../../../components/LicensorAddTaxDocumentModal";
import LicensorAddEditInvoiceDrawer from "../../../components/LicensorAddEditInvoiceDrawer";
import AddPaymentProofModal from "../../../components/AddPaymentProofModal";
const { confirm } = Modal;
const { TextArea } = Input;

const { TabPane } = Tabs;

const PartnerInvoice = () => {
  const [isUserAdmin, setIsUserAdmin] = useState(false);
  const [isUserLicensor, setIsUserLicensor] = useState(false);
  const [isUserPartner, setIsUserPartner] = useState(false);
  const [isUserStaff, setIsUserStaff] = useState(false);
  const [isAdminApprover, setIsAdminApprover] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [isModalVisible,] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [filterParams, setFilterParams] = useState({});
  const [sortOrder, setSortOrder] = useState(null);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [taxTotalCount, setTaxTotalCount] = useState(0);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [selectedViewItem, setSelectedViewItem] = useState(null);
  const [isViewItemLoading, setIsViewItemLoading] = useState(false);
  const [isTaxModalVisible, setIsTaxModalVisible] = useState(false);
  const [selectedTaxItem, setSelectedTaxItem] = useState(null);
  const [isInvoiceDrawerVisible, setIsInvoiceDrawerVisible] = useState(false);
  const [selectedInvoiceItem, setSelectedInvoiceItem] = useState(null);
  const [invoiceDrawerMode, setInvoiceDrawerMode] = useState('add');
  const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false);
  const [selectedPaymentItem, setSelectedPaymentItem] = useState(null);
  const [isDrawerActionLoading, setIsDrawerActionLoading] = useState(false);

  // Get partner list for filters
  const { data: partnerListData } = useGetPartnerListQuery({ limit: 1000 });

  // RTK Query hooks - only call API for active tab
  const { data: invoiceRequestdata, isLoading: isInvoiceLoading, isFetching: isInvoiceFetching, refetch: refetchInvoiceData } =
    useGetPartnerInvoiceDataQuery({
      limit: Number(pagination.pageSize) || 10,
      offset: (Number(pagination.current) - 1) * Number(pagination.pageSize) || 0,
      ordering: sortOrder,
      ...filterParams,
    }, {
      skip: activeTab !== "1", // Only fetch when Partner Invoice tab is active
    });
  const { data: taxRequestdata, isLoading: isTaxLoading, isFetching: isTaxFetching, refetch: refetchTaxData } =
    useGetPartnerTaxInvoiceDataQuery({
      limit: pagination.pageSize,
      offset: (Number(pagination.current) - 1) * Number(pagination.pageSize),
      ordering: sortOrder,
      ...filterParams,
    }, {
      skip: activeTab !== "2", // Only fetch when Tax Documents tab is active
    });
  const [downloadInvoice, { isLoading: isDownloading }] = useDownloadInvoiceDocumentMutation();
  const [sendReminder, { isLoading: isSendingReminder }] = useSendInvoiceReminderMutation();

  const { data: invoiceFilters } = useGetPartnerInvoiceFiltersQuery(undefined, {
    skip: activeTab !== "1"
  });

  const { data: taxInvoiceFilters } = useGetPartnerTaxInvoiceFiltersQuery(undefined, {
    skip: activeTab !== "2"
  });

  const [data, setData] = useState([]);
  const [taxData, setTaxData] = useState([]);
  const [form] = Form.useForm();
  const [isEditingPaymentDate, setIsEditingPaymentDate] = useState(false);
  const [editingPaymentItem, setEditingPaymentItem] = useState(null);

  const navigate = useNavigate();

  // const navigateToAddSalesData = () => {
  //   navigate("/partner/partner-invoice/raise-request");
  // };

  // const navigateToAddTaxData = () => {
  //   navigate("/partner/partner-tax-invoice/raise-request");
  // };

  const navigateToAddTaxData = (item = null) => {
    setSelectedTaxItem(item);
    setIsTaxModalVisible(true);
  };

  const navigateToAddSalesData = () => {
    setInvoiceDrawerMode('add');
    setSelectedInvoiceItem(null);
    setIsInvoiceDrawerVisible(true);
  };

  const navigateToContent = (item) => {
    setInvoiceDrawerMode('edit');
    setSelectedInvoiceItem(item);
    setIsInvoiceDrawerVisible(true);
  };

  const navigateToTaxForm = (item) => {
    navigateToAddTaxData(item);
  };

  useEffect(() => {
    setUserDetails(getUserInfo());
    setIsAdminApprover(getIsApprover());
    setIsUserAdmin(() => {
      return getRole() === "ADMIN";
    });
    setIsUserLicensor(() => {
      return getRole() === "LICENSOR";
    });
    setIsUserPartner(() => {
      return getRole() === "PARTNER";
    });
    setIsUserStaff(() => {
      return getRole() === "STAFF";
    });
  }, []);

  useEffect(() => {
    if (invoiceRequestdata) {
      if (Array.isArray(invoiceRequestdata)) {
        // Handle array response (old format)
        setData(invoiceRequestdata);
        setTotalCount(invoiceRequestdata.length);
      } else if (invoiceRequestdata.results && Array.isArray(invoiceRequestdata.results)) {
        // Handle paginated response with results property
        setData(invoiceRequestdata.results);
        setTotalCount(invoiceRequestdata.count || invoiceRequestdata.results.length);
      } else {
        // Direct object assignment
        setData(invoiceRequestdata);
        setTotalCount(invoiceRequestdata.length || 0);
      }
    }
  }, [invoiceRequestdata]);

  useEffect(() => {
    if (taxRequestdata) {
      if (Array.isArray(taxRequestdata)) {
        // Handle array response (old format)
        setTaxData(taxRequestdata);
        setTaxTotalCount(taxRequestdata.length);
      } else if (taxRequestdata.results && Array.isArray(taxRequestdata.results)) {
        // Handle paginated response with results property
        setTaxData(taxRequestdata.results);
        setTaxTotalCount(taxRequestdata.count || taxRequestdata.results.length);
      } else {
        // Direct object assignment
        setTaxData(taxRequestdata);
        setTaxTotalCount(taxRequestdata.length || 0);
      }
    }
  }, [taxRequestdata]);

  const invoiceDataRevise = () => {
    if (isUserAdmin && data) {
      const revisedData = data.map(item => ({ ...item })); // Create deep copy of each object
      for (let index = 0; index < revisedData.length; index++) {
        if (revisedData[index].partner_status == "INVALID" && revisedData[index].licensor_status == "UNDER PROCESS") {
          revisedData[index].licensor_status = "INVALID"
        }
        if (revisedData[index].partner_status == "NEEDS REVISION" && revisedData[index].licensor_status == "UNDER PROCESS") {
          revisedData[index].licensor_status = "NEEDS REVISION"
        }
      }
      return revisedData;
    }
    return data || [];
  }

  // const navigateToContent = (item) => {
  //   navigate(`/partner/partner-invoice/edit-request/${item.tracking_id}`);
  // };

  // const navigateToPaymentContent = (item) => {
  //   navigate(`/partner/partner-invoice/add-payment-proof/edit-request/${item.tracking_id}`);
  // };

  const navigateToPaymentContent = (item) => {
    setSelectedPaymentItem(item);
    setIsPaymentModalVisible(true);
  };

  // const navigateToTaxForm = (item) => {
  //   navigate(`/partner/partner-tax-invoice/edit-request/${item.tax_id}`);
  // };

  const navigateToViewContent = (item) => {
    navigate(`/partner/partner-invoice/view/${item.tracking_id}`);
  };

  const navigateToTaxViewContent = (item) => {
    navigate(`/partner/tax-invoice/view/${item.tax_id}`);
  };

    const handleInvoiceDrawerSuccess = () => {
    setIsInvoiceDrawerVisible(false);
    setSelectedInvoiceItem(null);
    // Refetch the invoice data to show updated results
    refetchInvoiceData();
  };

  const handlePaymentDateUpdate = (date, item) => {
    if (!date) return;

    const formData = new FormData();
    formData.append("payment_date", moment(date).format('YYYY-MM-DDT00:00:00Z'));
    formData.append("partner_id", parseInt(item.partner_id?.partner_id));

    dispatch(
      editRoyaltyInvoiceRequestData(
        item.tracking_id,
        formData,
        () => {
          refetchInvoiceData();
          setIsEditingPaymentDate(false);
          setEditingPaymentItem(null);
          // Update the selectedViewItem to reflect the new payment date immediately
          setSelectedViewItem(prev => ({
            ...prev,
            payment_date: moment(date).format('YYYY-MM-DDT00:00:00Z')
          }));
        },
        "Payment date updated"
      )
    );
  };

  const showCommentsForm = () => {
    return (
      <Form form={form} layout="vertical" className="mt-20">
        <div className="mb-10">
          <span>Add comments for partner:</span>
        </div>
        <Form.Item
          name="comment"
          className="mb-0"
          rules={[
            {
              required: isUserAdmin,
              message: isUserAdmin
                ? "Enter comments for partner"
                : "Enter comments for admin",
            },
          ]}
        >
          <TextArea placeholder="Enter comments here" />
        </Form.Item>
      </Form>
    );
  };

  const dispatch = useDispatch();

  const showApproveConfirm = (item, partner_id) => {
    confirm({
      title: "Do you want to submit the report?",
      className: "btn-confirm-green",
      content: showCommentsForm(),
      icon: <CheckCircleOutlined />,
      okText: "Submit",
      cancelText: "Cancel",
      onOk(close) {
        setIsDrawerActionLoading(true);
        form.validateFields().then((values) => {
          const approveFormData = new FormData();

          // Check if it's a tax document or invoice
          if (selectedViewItem?.tax_id) {
            // Tax document logic - matches the original isUserPartner check
            if (isUserPartner) {
              approveFormData.append("status", "ACCEPTED");
            } else {
              approveFormData.append("status", "APPROVED");
              approveFormData.append("is_approved", true);
            }
            approveFormData.append("comment", values.comment);
            approveFormData.append("partner_id", parseInt(partner_id));

            dispatch(editTaxInvoiceRequest(
              item,
              approveFormData,
              () => {
                setIsDrawerActionLoading(false);
                refetchTaxData();
                fetchData();
              },
              "Approved"
            ));
          } else {
            // Royalty invoice logic
            if (isUserPartner) {
              approveFormData.append("licensor_status", "ACCEPTED");
            } else {
              approveFormData.append("licensor_status", "APPROVED");
              approveFormData.append("is_approved", true);
            }
            approveFormData.append("licensor_comment", values.comment);
            approveFormData.append("partner_id", parseInt(partner_id));

            dispatch(editRoyaltyInvoiceRequestData(
              item,
              approveFormData,
              () => {
                setIsDrawerActionLoading(false);
                refetchInvoiceData();
                fetchData();
              },
              "Approved"
            ));
          }

          close();
        }).catch(() => {
          setIsDrawerActionLoading(false);
        });
      },
      onCancel() {
        form.resetFields(["comment"]);
      },
    });
  };

  const showRejectConfirm = (item, partner_id) => {
    confirm({
      title: "Do you want to request for revision?",
      className: "btn-confirm-red",
      content: showCommentsForm(),
      okText: "Needs Revision",
      cancelText: "Cancel",
      icon: <CloseCircleOutlined />,
      onOk(close) {
        setIsDrawerActionLoading(true);
        form.validateFields().then((values) => {
          const rejectFormData = new FormData();

          // Check if it's a tax document or invoice
          if (selectedViewItem?.tax_id) {
            rejectFormData.append("status", "NEEDS REVISION");
            rejectFormData.append("comment", values.comment);
            rejectFormData.append("partner_id", parseInt(partner_id));

            dispatch(editTaxInvoiceRequest(
              item,
              rejectFormData,
              () => {
                closeDrawer();
                setIsDrawerActionLoading(false);
                refetchTaxData();
              },
              "Needs Revision"
            ));
          } else {
            rejectFormData.append("licensor_status", "REJECTED");
            rejectFormData.append("licensor_comment", values.comment);
            rejectFormData.append("partner_id", parseInt(partner_id));

            dispatch(editRoyaltyInvoiceRequestData(
              item,
              rejectFormData,
              () => {
                closeDrawer();
                setIsDrawerActionLoading(false);
                refetchInvoiceData();
              },
              "Needs Revision"
            ));
          }

          close();
        }).catch(() => {
          setIsDrawerActionLoading(false);
        });
      },
      onCancel() {
        form.resetFields(["comment"]);
      },
    });
  };

  const showPaidConfirm = (item, partner_id) => {
    confirm({
      title: "Do you want to mark this request as paid?",
      className: "btn-confirm-primary",
      content: showCommentsForm(),
      okText: "Submit",
      cancelText: "Cancel",
      icon: <ExclamationCircleOutlined />,
      onOk(close) {
        setIsDrawerActionLoading(true);
        form.validateFields().then((values) => {
          const rejectFormData = new FormData();
          rejectFormData.append("licensor_status", "PAID");
          rejectFormData.append("partner_status", "PAID");
          rejectFormData.append("partner_comment", values.comment);
          rejectFormData.append("licensor_comment", values.comment);
          rejectFormData.append("partner_id", parseInt(partner_id));

          dispatch(editRoyaltyInvoiceRequestData(
            item,
            rejectFormData,
            () => {
              closeDrawer();
              setIsDrawerActionLoading(false);
              refetchInvoiceData();
            },
            "Status Sent"
          ));

          close();
        }).catch(() => {
          setIsDrawerActionLoading(false);
        });
      },
      onCancel() {
        form.resetFields(["comment"]);
      },
    });
  };

  const showInvalidConfirm = (item, partner_id) => {
    confirm({
      title: "Do you want to mark this request as invalid?",
      className: "btn-confirm-primary",
      content: showCommentsForm(),
      okText: "Submit",
      cancelText: "Cancel",
      icon: <WarningOutlined />,
      onOk(close) {
        setIsDrawerActionLoading(true);
        form.validateFields().then((values) => {
          const rejectFormData = new FormData();

          // Check if it's a tax document or invoice
          if (selectedViewItem?.tax_id) {
            rejectFormData.append("status", "INVALID");
            rejectFormData.append("comment", values.comment);
            rejectFormData.append("partner_id", parseInt(partner_id));
            rejectFormData.append("is_approved", false);

            dispatch(editTaxInvoiceRequest(
              item,
              rejectFormData,
              () => {
                closeDrawer();
                setIsDrawerActionLoading(false);
                refetchTaxData();
              },
              "Status Sent"
            ));
          } else {
            rejectFormData.append("partner_status", "INVALID");
            rejectFormData.append("partner_comment", values.comment);
            rejectFormData.append("partner_id", parseInt(partner_id));
            rejectFormData.append("is_approved", false);

            dispatch(editRoyaltyInvoiceRequestData(
              item,
              rejectFormData,
              () => {
                closeDrawer();
                setIsDrawerActionLoading(false);
                refetchInvoiceData();
              },
              "Status Sent"
            ));
          }

          close();
        }).catch(() => {
          setIsDrawerActionLoading(false);
        });
      },
      onCancel() {
        form.resetFields(["comment"]);
      },
    });
  };

  const showNeedRevisionConfirm = (item, partner_id) => {
    confirm({
      title: "Do you want to request for revision?",
      className: "btn-confirm-primary",
      content: showCommentsForm(),
      okText: "Submit",
      cancelText: "Cancel",
      icon: <WarningOutlined />,
      onOk(close) {
        setIsDrawerActionLoading(true);
        form.validateFields().then((values) => {
          const rejectFormData = new FormData();

          // Check if it's a tax document or invoice
          if (selectedViewItem?.tax_id) {
            rejectFormData.append("status", "NEEDS REVISION");
            rejectFormData.append("comment", values.comment);
            rejectFormData.append("partner_id", parseInt(partner_id));

            dispatch(editTaxInvoiceRequest(
              item,
              rejectFormData,
              () => {
                closeDrawer();
                setIsDrawerActionLoading(false);
                refetchTaxData();
              },
              "Needs Revision"
            ));
          } else {
            rejectFormData.append("partner_status", "NEEDS REVISION");
            rejectFormData.append("partner_comment", values.comment);
            rejectFormData.append("partner_id", parseInt(partner_id));

            dispatch(editRoyaltyInvoiceRequestData(
              item,
              rejectFormData,
              () => {
                closeDrawer();
                setIsDrawerActionLoading(false);
                refetchInvoiceData();
              },
              "Needs Revision"
            ));
          }

          close();
        }).catch(() => {
          setIsDrawerActionLoading(false);
        });
      },
      onCancel() {
        form.resetFields(["comment"]);
      },
    });
  };

  const showDrawer = (item) => {
    setSelectedViewItem(item);
    setIsDrawerVisible(true);
  };

  const closeDrawer = () => {
    setIsDrawerVisible(false);
    setSelectedViewItem(null);
    form.resetFields();
  };

  const handlePaymentProofSuccess = () => {
    setIsPaymentModalVisible(false);
    setIsDrawerVisible(false);
    refetchInvoiceData();
  };

  const renderDrawerContent = () => {
    if (!selectedViewItem) return null;

    const labelStyle = { width: "200px" };

    return (
      <div className="drawer-outer-container" style={{ marginTop: '24px' }}>
        <div className="drawer-content-container">
          <Descriptions
            bordered
            column={1}
            style={{
              boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
              borderRadius: "10px",
            }}
          >
            <Descriptions.Item label="Company Name" style={labelStyle}>
              {selectedViewItem?.partner_id?.company_name}
            </Descriptions.Item>
            <Descriptions.Item label="Issue Date" style={labelStyle}>
              {selectedViewItem.issue_date ? moment(selectedViewItem.issue_date).format("DD/MM/YYYY") : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Invoice Due Date" style={labelStyle}>
              {selectedViewItem.invoice_due_date ? moment(selectedViewItem.invoice_due_date).format("DD/MM/YYYY") : "-"}
            </Descriptions.Item>
            {selectedViewItem?.payment_date && (
              <Descriptions.Item label="Payment Date" style={labelStyle}>
                {isEditingPaymentDate && editingPaymentItem?.tracking_id === selectedViewItem.tracking_id ? (
                  <DatePicker
                    defaultValue={selectedViewItem?.payment_date ? moment(selectedViewItem.payment_date) : null}
                    format="DD/MM/YYYY"
                    onChange={(date) => handlePaymentDateUpdate(date, selectedViewItem)}
                    onBlur={() => {
                      setIsEditingPaymentDate(false);
                      setEditingPaymentItem(null);
                    }}
                    autoFocus
                  />
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {selectedViewItem?.payment_date ?
                      moment(selectedViewItem.payment_date).format("DD/MM/YYYY")
                      : "Not set"}
                    {isUserAdmin &&
                      selectedViewItem.partner_status === "PAID" &&
                      selectedViewItem.licensor_status !== "PAID" && (
                        <EditOutlined
                          style={{ cursor: 'pointer', marginLeft: '8px' }}
                          onClick={() => {
                            setIsEditingPaymentDate(true);
                            setEditingPaymentItem(selectedViewItem);
                          }}
                        />
                    )}
                  </div>
                )}
              </Descriptions.Item>
            )}
            <Descriptions.Item label="Amount" style={labelStyle}>
              {selectedViewItem.amount}
            </Descriptions.Item>
            <Descriptions.Item label="Quarter" style={labelStyle}>
              {selectedViewItem.quarter}
            </Descriptions.Item>
            <Descriptions.Item label="Year" style={labelStyle}>
              {selectedViewItem.year}
            </Descriptions.Item>
            <Descriptions.Item label="Status" style={labelStyle}>
              {isUserPartner ? (
                <span
                  style={{
                    color:
                      selectedViewItem.partner_status === "PAID" ||
                        selectedViewItem.partner_status === "APPROVED"
                        ? "green"
                        : selectedViewItem.partner_status === "INVALID" ||
                          selectedViewItem.partner_status === "REJECTED"
                          ? "red"
                          : "black",
                  }}
                >
                  {selectedViewItem.partner_status}
                </span>
              ) : (
                <span
                  style={{
                    color:
                      selectedViewItem.licensor_status === "PAID" ||
                        selectedViewItem.licensor_status === "APPROVED"
                        ? "green"
                        : selectedViewItem.licensor_status === "INVALID" ||
                          selectedViewItem.licensor_status === "REJECTED"
                          ? "red"
                          : "black",
                  }}
                >
                  {selectedViewItem.licensor_status}
                </span>
              )}
            </Descriptions.Item>
            {selectedViewItem?.licensor_comment && (
              <Descriptions.Item label="Comments" style={labelStyle}>
                {selectedViewItem.licensor_comment}
              </Descriptions.Item>
            )}
            <Descriptions.Item label="Invoice" style={labelStyle}>
              {selectedViewItem?.invoice_file?.map((file, index) => (
                <React.Fragment key={file.id || index}>
                  <a
                    href={file.document}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    INVOICE {index + 1}
                  </a>
                  <br />
                </React.Fragment>
              ))}
            </Descriptions.Item>
            <Descriptions.Item label="Payment Proof" style={labelStyle}>
              {selectedViewItem?.payment_file?.map((file, index) => (
                <React.Fragment key={file.id || index}>
                  <a
                    href={file.document}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    PAYMENT PROOF {index + 1}
                  </a>
                  <br />
                </React.Fragment>
              ))}
            </Descriptions.Item>
          </Descriptions>
        </div>
        {(isUserAdmin || isUserPartner) && (
          <div className="drawer-action-buttons-container" style={{ marginTop: '24px' }}>
            {!selectedViewItem.tax_id && renderActionButtons()}
          </div>
        )}
      </div>
    );
  };

  const renderTaxDrawerContent = () => {
    if (!selectedViewItem) return null;

    const labelStyle = { width: "200px" };

    return (
      <div className="drawer-outer-container" style={{ marginTop: '24px' }}>
        <div className="drawer-content-container">
          <Descriptions
            bordered
            column={1}
            style={{
              boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
              borderRadius: "10px",
            }}
          >
            <Descriptions.Item label="Year" style={labelStyle}>
              {selectedViewItem.year}
            </Descriptions.Item>
            <Descriptions.Item label="Company Name" style={labelStyle}>
              {selectedViewItem?.partner_id?.company_name}
            </Descriptions.Item>
            <Descriptions.Item label="Licensor Name" style={labelStyle}>
              {selectedViewItem?.licensor_id?.first_name} {selectedViewItem?.licensor_id?.last_name}
            </Descriptions.Item>
            {(isUserAdmin || isUserPartner) && (
              <Descriptions.Item label="Status" style={labelStyle}>
                <span
                  style={{
                    color:
                      selectedViewItem.status === "APPROVED"
                        ? "green"
                        : selectedViewItem.status === "NEEDS REVISION"
                          ? "red"
                          : "black",
                  }}
                >
                  {selectedViewItem.status}
                </span>
              </Descriptions.Item>
            )}
            {isUserLicensor && (
              <Descriptions.Item label="Status" style={labelStyle}>
                <span
                  style={{
                    color:
                      selectedViewItem.licensor_status === "APPROVED"
                        ? "green"
                        : selectedViewItem.licensor_status === "NEEDS REVISION"
                          ? "red"
                          : "black",
                  }}
                >
                  {selectedViewItem.licensor_status}
                </span>
              </Descriptions.Item>
            )}
            {selectedViewItem?.comment && (
              <Descriptions.Item label="Comments" style={labelStyle}>
                {selectedViewItem.comment}
              </Descriptions.Item>
            )}
            <Descriptions.Item label="Document" style={labelStyle}>
              {selectedViewItem?.invoice_file?.map((file, index) => (
                <React.Fragment key={file.id || index}>
                  <a
                    href={file.document}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    DOC {index + 1}
                  </a>
                  <br />
                </React.Fragment>
              ))}
            </Descriptions.Item>
          </Descriptions>
        </div>
        {(isUserAdmin || isUserPartner) && (
          <div className="drawer-action-buttons-container" style={{ marginTop: '24px' }}>
            {selectedViewItem.tax_id && renderActionButtons()}
          </div>
        )}
      </div>
    );
  };

  const renderDrawerTitle = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <span>{selectedViewItem?.tax_id ? "Tax Document Details" : "Invoice Details"}</span>
        <CloseOutlined onClick={closeDrawer} style={{ cursor: 'pointer' }} />
      </div>
    );
  };

  const renderActionButtons = () => {
    if (!selectedViewItem) return null;

    // For invoice items
    if (!selectedViewItem.tax_id) {
      let isDisabled = selectedViewItem.licensor_status === "PENDING" ||
        selectedViewItem.partner_status === "NEEDS REVISION";
      let isDisabledPaid = selectedViewItem.licensor_status === "PAID";

      return (
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {isUserAdmin && isDisabled && (
            <>
              <Button
                className="gx-btn-success RSDApproveButton"
                icon={<CheckOutlined />}
                onClick={() =>
                  showApproveConfirm(
                    selectedViewItem.tracking_id || "temp-id",
                    selectedViewItem.partner_id?.partner_id || 1,
                  )
                }
                id={`approve-${selectedViewItem.tracking_id || "temp-id"}`}
                disabled={!isDisabled}
              >
                Submit
              </Button>

              <Button
                className="gx-btn-danger RSDRejectButton"
                icon={<CloseOutlined />}
                onClick={() =>
                  showRejectConfirm(
                    selectedViewItem.tracking_id || "temp-id",
                    selectedViewItem.partner_id?.partner_id || 1,
                  )
                }
                id={`reject-${selectedViewItem.tracking_id || "temp-id"}`}
                disabled={!isDisabled}
              >
                Needs Revision
              </Button>
            </>
          )}

          {isUserAdmin &&
            selectedViewItem.partner_status === "PAID" &&
            selectedViewItem.licensor_status !== "PAID" && (
              <>
                <Button
                  className="gx-btn-success RSDApproveButton"
                  icon={<CheckOutlined />}
                  onClick={() =>
                    showPaidConfirm(
                      selectedViewItem.tracking_id,
                      selectedViewItem.partner_id.partner_id,
                    )
                  }
                  id={`paid-${selectedViewItem.tracking_id}`}
                  disabled={isDisabledPaid}
                >
                  Paid
                </Button>

                <Button
                  className="gx-btn-warning RSDClarificationButton"
                  icon={<WarningOutlined />}
                  onClick={() =>
                    showInvalidConfirm(
                      selectedViewItem.tracking_id || "temp-id",
                      selectedViewItem.partner_id?.partner_id || 1,
                    )
                  }
                  id={`invalid-${selectedViewItem.tracking_id}`}
                  disabled={isDisabledPaid}
                >
                  Invalid
                </Button>
              </>
            )}

          {isUserPartner &&
            selectedViewItem.partner_status === "UNDER PROCESS" && (
              <>
                <Button
                  type="primary"
                  className="gx-btn-primary RSDPaymentProofButton"
                  icon={<UploadOutlined />}
                  id="add-payment-proof"
                  onClick={() => navigateToPaymentContent(selectedViewItem)}
                >
                  Add Payment Proof
                </Button>

                <Button
                  className="gx-btn-danger"
                  icon={<CloseOutlined />}
                  onClick={() =>
                    showNeedRevisionConfirm(
                      selectedViewItem.tracking_id,
                      selectedViewItem.partner_id.partner_id,
                    )
                  }
                  id={`revision-${selectedViewItem.tracking_id}`}
                >
                  Needs Revision
                </Button>
              </>
            )}

          {isUserPartner &&
            selectedViewItem.partner_status === "INVALID" && (
              <Button
                type="primary"
                id="edit-payment-proof"
                onClick={() => navigateToPaymentContent(selectedViewItem)}
              >
                <UploadOutlined />
                Edit Payment Proof
              </Button>
            )}
        </div>
      );
    }

    // For tax document items
    else {
      // Decide whether the current user can act, based on the workflow status.
      // - Partner acts only when the admin has forwarded the document (status: UNDER PROCESS).
      // - Admin acts when the licensor has (re)submitted (status: PENDING) OR when the partner
      //   has requested a revision. A partner revision sets status to "NEEDS REVISION" while
      //   keeping licensor_status as "UNDER PROCESS" (still the admin's turn), whereas an
      //   admin-forwarded revision sets licensor_status to "NEEDS REVISION" (the licensor's
      //   turn). Both states share status === "NEEDS REVISION", so licensor_status is what
      //   distinguishes them and keeps the admin disabled once the revision is with the licensor.
      let isDisabled;
      if (isUserPartner) {
        isDisabled = selectedViewItem.status !== "UNDER PROCESS";
      } else {
        const adminCanAct =
          selectedViewItem.status === "PENDING" ||
          (selectedViewItem.status === "NEEDS REVISION" &&
            selectedViewItem.licensor_status === "UNDER PROCESS");
        isDisabled = !adminCanAct;
      }

      return (
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {(isUserAdmin || isUserPartner) && (
            <>
              <Button
                className="gx-btn-success RSDApproveButton"
                icon={<CheckOutlined />}
                onClick={() =>
                  showApproveConfirm(
                    selectedViewItem.tax_id || "temp-id",
                    selectedViewItem.partner_id?.partner_id || 1,
                  )
                }
                id={`approve-${selectedViewItem.tax_id || "temp-id"}`}
                disabled={isDisabled}
              >
                {isUserPartner ? "Accept" : "Submit"}
              </Button>

              <Button
                className="gx-btn-yellow RSDRevisionsButton"
                icon={<ExclamationCircleOutlined />}
                onClick={() =>
                  showNeedRevisionConfirm(
                    selectedViewItem.tax_id || "temp-id",
                    selectedViewItem.partner_id?.partner_id || 1,
                  )
                }
                id={`revision-${selectedViewItem.tax_id || "temp-id"}`}
                disabled={isDisabled}
              >
                Needs Revision
              </Button>
            </>
          )}
        </div>
      );
    }
  };

  const columns = [
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
      align: "center",
      width: "8%",
      filteredValue: filteredInfo.year || null,
      filterDropdown: (props) => (
        <CustomFilterDropdown
          {...props}
          dataIndex="year"
          options={invoiceFilters?.filters?.year || []}
          placeholder="Select years..."
          confirm={(selectedKeys) => handleFilterConfirm(selectedKeys, props.confirm, "year")}
          clearFilters={() => handleFilterReset(props.clearFilters, "year")}
        />
      ),
      // sorter: true,
    },
    {
      title: "Quarter",
      dataIndex: "quarter",
      key: "quarter",
      align: "center",
      width: "10%",
      filteredValue: filteredInfo.quarter || null,
      filterDropdown: (props) => (
        <CustomFilterDropdown
          {...props}
          dataIndex="quarter"
          options={invoiceFilters?.filters?.quarter || []}
          placeholder="Select quarters..."
          confirm={(selectedKeys) => handleFilterConfirm(selectedKeys, props.confirm, "quarter")}
          clearFilters={() => handleFilterReset(props.clearFilters, "quarter")}
        />
      ),
      render: (text, record) => (
        <Tooltip>
          {record.quarter} - {record.year}
        </Tooltip>
      ),
    },
    ...(isUserAdmin || isUserLicensor || isUserStaff
      ? [
        {
          title: "Partner Name",
          dataIndex: ["partner_id", "company_name"],
          key: "partner_name",
          align: "center",
          width: "12%",
          filteredValue: filteredInfo.partner_name || null,
          filterDropdown: (props) => (
            <CustomFilterDropdown
              {...props}
              dataIndex="partner_name"
              options={invoiceFilters?.filters?.partner || []}
              placeholder="Search partner names..."
              confirm={(selectedKeys) => handleFilterConfirm(selectedKeys, props.confirm, "partner_name")}
              clearFilters={() => handleFilterReset(props.clearFilters, "partner_name")}
            />
          ),
        },
      ]
      : []),

    ...(isUserAdmin || isUserPartner || isUserStaff
      ? [
        {
          title: "Licensor Name",
          dataIndex: ["licensor_id", "first_name"],
          key: "licensor_name",
          align: "center",
          width: "10%",
          filteredValue: filteredInfo.licensor_name || null,
          filterDropdown: (props) => (
            <CustomFilterDropdown
              {...props}
              dataIndex="licensor_name"
              options={invoiceFilters?.filters?.licensor_name || []}
              placeholder="Search licensor names..."
              confirm={(selectedKeys) => handleFilterConfirm(selectedKeys, props.confirm, "licensor_name")}
              clearFilters={() => handleFilterReset(props.clearFilters, "licensor_name")}
            />
          ),
        },
      ]
      : []),

    {
      title: "Issue Date",
      dataIndex: "issue_date",
      key: "issue_date",
      align: "center",
      width: "10%",
      sorter: true,
      render: (text, record) => moment(record.issue_date).format("DD/MM/YYYY"),
    },
    {
      title: "Amount (USD)",
      dataIndex: "amount",
      key: "amount",
      align: "center",
      width: "10%",
      sorter: true,
    },
    {
      title: "Payment Date",
      dataIndex: "payment_date",
      key: "payment_date",
      align: "center",
      width: "10%",
      sorter: true,
      render: (text, record) => {
        if (record.payment_date) {
          return moment(record.payment_date).format("DD/MM/YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: "Invoice Due Date",
      dataIndex: "invoice_due_date",
      key: "invoice_due_date",
      align: "center",
      width: "10%",
      sorter: true,
      render: (text, record) => {
        if (record.invoice_due_date) {
          return moment(record.invoice_due_date).format("DD/MM/YYYY");
        } else {
          return "-";
        }
      },
    },

    {
      title: "Remaining Days",
      dataIndex: "remaining_days",
      key: "remaining_days",
      align: "center",
      width: "10%",
      render: (text, record) => {
        if (record.licensor_status === "PAID" || record.partner_status === "PAID") {
          return "-";
        }

        const invoiceDueDate = moment(new Date(record.invoice_due_date).toDateString());
        const todayDate = moment(new Date().toDateString());

        if (invoiceDueDate.isValid()) {
          var diffDays = invoiceDueDate.diff(todayDate, "days");
          return diffDays;
        }
        return "-";
      },
    },

    ...(isUserAdmin || isUserLicensor || isUserStaff
      ? [
        {
          title: "Status",
          dataIndex: "licensor_status",
          key: "licensor_status",
          align: "center",
          width: "12%",
          filteredValue: filteredInfo.licensor_status || null,
          filterDropdown: (props) => (
            <CustomFilterDropdown
              {...props}
              dataIndex="licensor_status"
              options={invoiceFilters?.filters?.status || []} // Pass simple array, not objects
              placeholder="Select status..."
              confirm={(selectedKeys) => handleFilterConfirm(selectedKeys, props.confirm, "licensor_status")}
              clearFilters={() => handleFilterReset(props.clearFilters, "licensor_status")}
            />
          ),
          render: (text, record) => (
            <Tooltip
              title={text !== "PENDING" ? record.licensor_comment : null}
            >
              <span
                style={{
                    color:
                      text === "PAID" || text === "APPROVED" || text === "ACCEPTED"
                        ? "limegreen"
                        : text === "INVALID" || text === "NEEDS REVISION"
                        ? "red"
                        : text === "UNDER PROCESS"
                        ? "orange"
                        : "black",
                  }}
              >
                {text}
                {text !== "PENDING" && (
                  <InfoCircleTwoTone
                    className="ml-10"
                    twoToneColor={["#718096", "#FFF"]}
                  />
                )}
              </span>
            </Tooltip>
          ),
        },
      ]
      : []),
    ...(isUserPartner
      ? [
        {
          title: "Status",
          dataIndex: "partner_status",
          key: "partner_status",
          align: "center",
          width: "12%",
          filteredValue: filteredInfo.partner_status || null,
          filterDropdown: (props) => ( // Replace filters with filterDropdown
            <CustomFilterDropdown
              {...props}
              dataIndex="partner_status"
              options={invoiceFilters?.filters?.status || []} // Pass simple array
              placeholder="Select status..."
              confirm={(selectedKeys) => handleFilterConfirm(selectedKeys, props.confirm, "partner_status")}
              clearFilters={() => handleFilterReset(props.clearFilters, "partner_status")}
            />
          ),
          render: (text, record) => (
            <Tooltip
              title={text !== "PENDING" ? record.partner_comment : null}
            >
              <span
                style={{
                    color:
                      text === "PAID" || text === "APPROVED" || text === "ACCEPTED"
                        ? "limegreen"
                        : text === "UNDER PROCESS"
                        ? "orange"
                        : text === "INVALID" || text === "REJECTED"
                        ? "red"
                        : "black",
                  }}
              >
                {text}
                {text !== "PENDING" && (
                  <InfoCircleTwoTone
                    className="ml-10"
                    twoToneColor={["#718096", "#FFF"]}
                  />
                )}
              </span>
            </Tooltip>
          ),
        },
      ]
      : []),
    {
      title: "Invoice",
      dataIndex: "invoice_file",
      key: "invoice_file",
      align: "center",
      width: "8%",
      render: (files) => (
        <Tooltip style={{ textAlign: "center" }}>
          {files?.map((file, index) => (
            <>
              <a
                key={file.id}
                href={file.document}
                target="_blank"
                rel="noopener noreferrer"
              >
                INVOICE {index + 1}
              </a>
              <br />
            </>
          ))}
        </Tooltip>
      ),
    },
    {
      title: "Payment Proof",
      dataIndex: "payment_file",
      key: "payment_file",
      align: "center",
      width: "12%",
      render: (files) => (
        <Tooltip style={{ textAlign: "center" }}>
          {files?.map((file, index) => (
            <>
              <a
                key={file.id}
                href={file.document}
                target="_blank"
                rel="noopener noreferrer"
              >
                PAYMENT PROOF {index + 1}
              </a>
              <br />
            </>
          ))}
        </Tooltip>
      ),
    },

    {
      title: "Action",
      key: "operation",
      align: "center",
      width: "8%",
      render: (item) => (
        <div style={{ display: "inline-flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
          {isUserAdmin ? (
            <>
              <Tooltip title="View request">
                <img
                  className="icon"
                  style={{ cursor: "pointer", width: "100%", padding: 0 }}
                  src={eyeIcon}
                  onClick={() => showDrawer(item)}
                  id={"view-" + item.tracking_id}
                  alt="eye"
                />
              </Tooltip>
              <Tooltip title="Send Reminder">
                <BellOutlined
                  className="font-20"
                  style={{ color: item.licensor_status === "PAID" ? '#d9d9d9' : '#283a8a', cursor: item.licensor_status === "PAID" ? 'not-allowed' : 'pointer' }}
                  onClick={() => {
                    if (item.licensor_status !== "PAID") {
                      sendReminder(item.tracking_id);
                    }
                  }}
                />
              </Tooltip>
            </>
          ) : (
            <>
              <Button
                type="link"
                className="margin-0"
                style={{padding: 0}}
                onClick={() => showDrawer(item)}
                id={"view-" + item.tracking_id}
              >
                <Tooltip title="View request">
                <img
                  className="icon"
                  style={{ cursor: "pointer", width: "100%" }}
                  src={eyeIcon}
                  alt="eye"
                />
                </Tooltip>
              </Button>
              {isUserLicensor && (
                <Button
                  type="link"
                  className="margin-0"
                  style={{padding: 0}}
                  id={"upload-" + item.tracking_id}
                  disabled={
                    item.licensor_status === "PAID" ||
                    item.licensor_status === "PENDING" ||
                    item.licensor_status === "APPROVED"
                  }
                  onClick={() => {
                    navigateToContent(item);
                  }}
                >
                  <Tooltip title="Edit">
                    <EditOutlined twoToneColor="#00AEEF" className="font-20" />
                  </Tooltip>
                </Button>
              )}
              {isUserPartner && (
                <Button
                  type="link"
                  className="margin-0"
                  style={{padding: 0}}
                  id={"upload-" + item.tracking_id}
                  disabled={
                    item.partner_status === "PAID" ||
                    item.partner_status === "PENDING" ||
                    item.partner_status === "UNDER PROCESS"
                  }
                  onClick={() => {
                    navigateToPaymentContent(item);
                  }}
                >
                  <Tooltip title="Edit">
                    <EditOutlined twoToneColor="#00AEEF" className="font-20" />
                  </Tooltip>
                </Button>
              )}
            </>
          )}
          {/* {isUserLicensor && (
            <Tooltip title="Send Reminder">
              <BellOutlined
                className="font-20"
                style={{ color: item.licensor_status === "PAID" ? '#d9d9d9' : '#28398a' }}
                onClick={() => {
                  if (item.licensor_status !== "PAID") {
                    sendReminder(item.tracking_id);
                  }
                }}
              />
            </Tooltip>
          )} */}
        </div>
      ),
    },
  ];

  const taxColumns = [
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
      align: "center",
      width: "10%",
      filteredValue: filteredInfo.year || null,
      filterDropdown: (props) => (
        <CustomFilterDropdown
          {...props}
          dataIndex="year"
          options={taxInvoiceFilters?.years || []}
          placeholder="Select years..."
          confirm={(selectedKeys) => handleFilterConfirm(selectedKeys, props.confirm, "year")}
          clearFilters={() => handleFilterReset(props.clearFilters, "year")}
        />
      ),
      // sorter: true,
    },
    ...(isUserAdmin || isUserPartner
      ? [
        {
          title: "Licensor Name",
          dataIndex: ["licensor_id", "first_name"],
          key: "licensor_name",
          align: "center",
          width: "15%",
          filteredValue: filteredInfo.licensor_name || null,
          filterDropdown: (props) => (
            <CustomFilterDropdown
              {...props}
              dataIndex="licensor_name"
              options={taxInvoiceFilters?.licensor_names || []}
              placeholder="Search licensor names..."
              confirm={(selectedKeys) => handleFilterConfirm(selectedKeys, props.confirm, "licensor_name")}
              clearFilters={() => handleFilterReset(props.clearFilters, "licensor_name")}
            />
          ),
        },
      ]
      : []),
    ...(isUserAdmin || isUserLicensor || isUserStaff
      ? [
        {
          title: "Partner Name",
          dataIndex: ["partner_id", "company_name"],
          key: "partner_name",
          align: "center",
          width: "15%",
          filteredValue: filteredInfo.partner_name || null,
          filterDropdown: (props) => (
            <CustomFilterDropdown
              {...props}
              dataIndex="partner_name"
              options={taxInvoiceFilters?.partners || []}
              placeholder="Search partner names..."
              confirm={(selectedKeys) => handleFilterConfirm(selectedKeys, props.confirm, "partner_name")}
              clearFilters={() => handleFilterReset(props.clearFilters, "partner_name")}
            />
          ),
        },
      ]
      : []),
    ...(isUserAdmin || isUserPartner || isUserStaff
      ? [
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          align: "center",
          width: "12%",
          filteredValue: filteredInfo.status || null,
          filterDropdown: (props) => (
            <CustomFilterDropdown
              {...props}
              dataIndex="status"
              options={taxInvoiceFilters?.statuses || []} // Pass simple array, not objects
              placeholder="Select status..."
              confirm={(selectedKeys) => handleFilterConfirm(selectedKeys, props.confirm, "status")}
              clearFilters={() => handleFilterReset(props.clearFilters, "status")}
            />
          ),
          render: (text, record) => (
            <Tooltip
              title={text !== "PENDING" ? record.licensor_comment : null}
            >
              <span
                style={{
                  color:
                    text === "PAID" || text === "APPROVED" || text === "ACCEPTED"
                      ? "limegreen"
                      : text === "INVALID" || text === "REJECTED" || text === "NEEDS REVISION"
                      ? "red"
                      : text === "UNDER PROCESS"
                      ? "orange"
                      : "black",
                }}
              >
                {text}
                {text !== "PENDING" && (
                  <InfoCircleTwoTone
                    className="ml-10"
                    twoToneColor={["#718096", "#FFF"]}
                  />
                )}
              </span>
            </Tooltip>
          ),
        },
      ]
      : [
        {
          title: "Status",
          dataIndex: "licensor_status",
          key: "status",
          align: "center",
          width: "12%",
          filteredValue: filteredInfo.licensor_status || null,
          filterDropdown: (props) => ( // Replace filters with filterDropdown
            <CustomFilterDropdown
              {...props}
              dataIndex="licensor_status"
              options={taxInvoiceFilters?.statuses || []} // Pass simple array
              placeholder="Select status..."
              confirm={(selectedKeys) => handleFilterConfirm(selectedKeys, props.confirm, "licensor_status")}
              clearFilters={() => handleFilterReset(props.clearFilters, "licensor_status")}
            />
          ),
          render: (text, record) => (
            <Tooltip
              title={text !== "PENDING" ? record.licensor_comment : null}
            >
              <span
                style={{
                  color:
                    text === "PAID" || text === "APPROVED" || text === "ACCEPTED"
                      ? "limegreen"
                      : text === "INVALID" || text === "REJECTED" || text === "NEEDS REVISION"
                      ? "red"
                      : text === "UNDER PROCESS"
                      ? "orange"
                      : "black",
                }}
              >
                {text}
                {text !== "PENDING" && (
                  <InfoCircleTwoTone
                    className="ml-10"
                    twoToneColor={["#718096", "#FFF"]}
                  />
                )}
              </span>
            </Tooltip>
          ),
        },
      ]),

    {
      title: "Documents",
      dataIndex: "invoice_file",
      key: "invoice_file",
      align: "center",
      width: "10%",
      render: (files) => (
        <Tooltip style={{ textAlign: "center" }}>
          {files?.map((file, index) => (
            <>
              <a
                key={file.id}
                href={file.document}
                target="_blank"
                rel="noopener noreferrer"
              >
                DOC {index + 1}
              </a>
              <br />
            </>
          ))}
        </Tooltip>
      ),
    },
    {
      title: "Action",
      key: "operation",
      align: "center",
      width: "8%",
      render: (item) => (
        <div style={{ display: "inline-flex" }}>
          {isUserAdmin || isUserPartner ? (
            <>
              <Tooltip title="View request">
                <img
                  className="icon ml-20"
                  style={{ cursor: "pointer" }}
                  src={eyeIcon}
                  onClick={() => showDrawer(item)}
                  id={"view-" + item.tax_id}
                  alt="eye"
                />
              </Tooltip>
            </>
          ) : (
            <>
              <Button
                type="link"
                className="margin-0"
                onClick={() => showDrawer(item)}
                id={"view-" + item.tax_id}
              >
                <Tooltip title="View request">
                  <img
                    className="icon ml-20"
                    style={{ cursor: "pointer" }}
                    src={eyeIcon}
                    alt="eye"
                  />
                </Tooltip>
              </Button>
            </>
          )}
          {isUserLicensor && (
            <Button
              type="link"
              className="margin-0"
              id={"upload-" + item.tracking_id}
              disabled={
                item.status === "PENDING" ||
                item.status === "APPROVED" ||
                item.status === "ACCEPTED"
              }
              onClick={() => {
                navigateToTaxForm(item);
              }}
            >
              <Tooltip title="Edit">
                <EditOutlined twoToneColor="#00AEEF" className="font-20" />
              </Tooltip>
            </Button>
          )}
        </div>
      ),
    },
  ];

  const displayGridCta = () => {
    return (
      <div>
        {isUserLicensor && (
          <Button
            type="primary"
            id="raise-request"
            onClick={navigateToAddSalesData}
            style={{ marginRight: "10px" }}
          >
            <MedicineBoxOutlined />
            Add Invoice
          </Button>
        )}
        {isUserLicensor && (
          <Button
            type="primary"
            id="raise-request"
            onClick={() => navigateToAddTaxData()}
            style={{ marginRight: "10px" }}
          >
            <MedicineBoxOutlined />
            Add Tax Document
          </Button>
        )}
        <Tooltip title={<IntlMessages id='invoice.download' />}>
          <Button
            id='invoice.download'
            className='mr-0'
            onClick={() => downloadInvoice({
              fileName: 'royalty-partner-invoice.csv',
              requestObj: {
                limit: pagination.pageSize,
                offset: (Number(pagination.current) - 1) * Number(pagination.pageSize),
              }
            })}
            loading={isDownloading}
          >
            <DownloadOutlined className='font-20' />
          </Button>
        </Tooltip>
      </div>
    );
  };

  // Add loading state combining both existing code and new code
  const isTableLoading = activeTab === "1" ? (isInvoiceLoading || isInvoiceFetching) : false;
  const isTaxTableLoading = activeTab === "2" ? (isTaxLoading || isTaxFetching) : false;

  // Custom Filter Dropdown Component
  const CustomFilterDropdown = ({
    options,
    selectedKeys,
    setSelectedKeys,
    confirm,
    clearFilters,
    placeholder = "Search...",
    dataIndex
  }) => {
    // Use filteredInfo state if available, otherwise use selectedKeys from Ant Design
    const currentValues = filteredInfo[dataIndex] || selectedKeys || [];
    
    return (
      <div style={{ padding: 8, width: 280 }}>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
          <Select
            mode="multiple"
            placeholder={placeholder}
            value={currentValues}
            onChange={(values) => {
              setSelectedKeys(values);
              // Immediately update our state when values change
              setFilteredInfo(prev => ({
                ...prev,
                [dataIndex]: values
              }));
            }}
            showSearch
            style={{
              width: '100%',
              minHeight: 20,
              marginBottom: 0,
              display: 'block'
            }}
            filterOption={(input, option) =>
              option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            maxTagCount="responsive"
            allowClear={false}
            dropdownRender={menu => (
              <>
                {menu}
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: 8,
                  padding: '0 8px'
                }}>
                  <Button
                    size="small"
                    onClick={() => {
                      setSelectedKeys([]);
                      setFilteredInfo(prev => ({
                        ...prev,
                        [dataIndex]: []
                      }));
                      clearFilters && clearFilters();
                    }}
                    style={{ flex: 1 }}
                  >
                    Reset
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => confirm && confirm(currentValues)}
                    style={{ flex: 1 }}
                  >
                    Apply
                  </Button>
                </div>
              </>
            )}
          >
            {options.map(option => (
              <Select.Option key={option} value={option}>
                {option}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8 }}>
          <Button
            size="small"
            style={{ flex: 1 }}
            onClick={() => {
              setSelectedKeys([]);
              setFilteredInfo(prev => ({
                ...prev,
                [dataIndex]: []
              }));
              clearFilters && clearFilters();
            }}
          >
            Reset
          </Button>
          <Button
            type="primary"
            size="small"
            style={{ flex: 1 }}
            onClick={() => confirm && confirm(currentValues)}
          >
            Apply
          </Button>
        </div>
      </div>
    );
  };

  const handleFilterConfirm = (selectedKeys, confirm, dataIndex) => {
    confirm();

    // Map frontend keys to backend parameter names
    const filterKeyMap = {
      year: 'year',
      quarter: 'quarter',
      partner_name: 'partner',
      licensor_name: 'licensor_name',
      licensor_status: 'status',
      partner_status: 'status',
      status: 'status'
    };

    const backendKey = filterKeyMap[dataIndex] || dataIndex;

    setFilterParams(prev => ({
      ...prev,
      [backendKey]: selectedKeys && selectedKeys.length > 0 ? selectedKeys : undefined
    }));

    // Update filteredInfo to maintain UI state
    setFilteredInfo(prev => ({
      ...prev,
      [dataIndex]: selectedKeys && selectedKeys.length > 0 ? selectedKeys : undefined
    }));
  };

  const handleFilterReset = (clearFilters, dataIndex) => {
    clearFilters();

    // Map frontend keys to backend parameter names
    const filterKeyMap = {
      year: 'year',
      quarter: 'quarter',
      partner_name: 'partner',
      licensor_name: 'licensor_name',
      licensor_status: 'status',
      partner_status: 'status',
      status: 'status'
    };

    const backendKey = filterKeyMap[dataIndex] || dataIndex;

    setFilterParams(prev => ({
      ...prev,
      [backendKey]: undefined
    }));

    // Update filteredInfo to maintain UI state
    setFilteredInfo(prev => ({
      ...prev,
      [dataIndex]: undefined
    }));
  };

  const handleTableChange = (paginationInfo, filters, sorter) => {
    // Handle pagination
    if (paginationInfo) {
      setPagination({
        current: paginationInfo.current,
        pageSize: paginationInfo.pageSize,
      });
    }

    // Handle filters - process both custom dropdowns and standard filters
    if (filters) {
      const newFilterParams = { ...filterParams };

      // Handle standard Ant Design filters (like status)
      Object.entries(filters).forEach(([key, values]) => {
        if (values && values.length > 0) {
          // Map frontend keys to backend parameter names
          const filterKeyMap = {
            licensor_status: 'status',
            partner_status: 'status',
            status: 'status'
          };

          const backendKey = filterKeyMap[key] || key;
          newFilterParams[backendKey] = values;
        } else {
          // Remove filter if no values selected
          const filterKeyMap = {
            licensor_status: 'status',
            partner_status: 'status',
            status: 'status'
          };

          const backendKey = filterKeyMap[key] || key;
          delete newFilterParams[backendKey];
        }
      });

      setFilterParams(newFilterParams);
      setFilteredInfo(filters);
    }

    // Handle sorting
    if (sorter && sorter.field) {
      const sortFieldMap = {
        issue_date: 'issue_date',
        payment_date: 'payment_date',
        invoice_due_date: 'invoice_due_date',
        amount: 'amount',
        year: 'year'
      };

      const backendField = sortFieldMap[sorter.field] || sorter.field;
      const ordering = sorter.order === 'descend' ? `-${backendField}` : backendField;
      setSortOrder(ordering);
    } else {
      setSortOrder(null);
    }
  };

  // Handle tab change
  const handleTabChange = (key) => {
    setActiveTab(key);
    // Reset pagination, filters, and sorting when switching tabs
    setPagination({
      current: 1,
      pageSize: 10
    });
    setFilterParams({});
    setFilteredInfo({});
    setSortOrder(null);
  };

  return (
    <div className="royalty-invoice-page">
      <Col span={24}>
      <div>
        <Tabs
          tabPosition='top'
          type='card'
          className='sales-report-tabs'
          tabBarExtraContent={displayGridCta()}
          activeKey={activeTab}
          onChange={handleTabChange}
        >
          <TabPane tab="Partner Invoice" key="1">
            {isTableLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "60vh",
                  width: "100vw",
                }}
              >
                <LoadingBar loading={true} />
              </div>
            ) : (
              <>
                <Row>
                  <Table
                    className="gx-table-responsive mpp-list-table"
                    columns={columns}
                    dataSource={invoiceDataRevise()}
                    bordered
                    scroll={{ y: 'calc(100vh - 250px)', x:'100%' }}
                    sticky={true}
                    style={{ width: '100%' }}
                    pagination={false}
                    onChange={handleTableChange}
                  />
                  <CustomPagination
                    current={pagination.current}
                    total={totalCount}
                    pageSize={pagination.pageSize}
                    onChange={(page, pageSize) => {
                      setPagination(prev => ({
                        ...prev,
                        current: page,
                        pageSize: pageSize,
                      }));
                    }}
                    showSizeChanger={true}
                    pageSizeOptions={['10', '20', '50', '100']}
                  />
                </Row>
              </>
            )}
          </TabPane>

          <TabPane tab="Tax Documents" key="2">
            {isTaxTableLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "60vh",
                  width: "100vw",
                }}
              >
                <LoadingBar loading={true} />
              </div>
            ) : (
              <>
                <Row>
                  <Table
                    className="gx-table-responsive mpp-list-table"
                    columns={taxColumns}
                    dataSource={taxData}
                    bordered
                    scroll={{ y: 'calc(100vh - 250px)', x:'100%' }}
                    sticky={true}
                    style={{ width: '100%' }}
                    pagination={false}
                    onChange={handleTableChange}
                  />
                  <CustomPagination
                    current={pagination.current}
                    total={taxTotalCount}
                    pageSize={pagination.pageSize}
                    onChange={(page, pageSize) => {
                      setPagination(prev => ({
                        ...prev,
                        current: page,
                        pageSize: pageSize,
                      }));
                    }}
                    showSizeChanger={true}
                    pageSizeOptions={['10', '20', '50', '100']}
                  />
                </Row>
              </>
            )}
          </TabPane>
        </Tabs>

      </div>
      <Drawer
        title={renderDrawerTitle()}
        placement="right"
        onClose={closeDrawer}
        open={isDrawerVisible}
        width="90%"
        className="royalty-sales-drawer"
        headerStyle={{ paddingBottom: 16 }}
        bodyStyle={{ paddingTop: 0, overflow: "hidden" }}
        closable={false}
      >
        {isViewItemLoading ? (
          <div className="drawer-loading-container">
            <LoadingBar loading={isViewItemLoading} />
          </div>
        ) : (
          <div style={{ position: 'relative' }}>
            {isDrawerActionLoading && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  zIndex: 1000,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '10px'
                }}
              >
                <Spin size="large" tip="Processing..." />
              </div>
            )}
            {selectedViewItem?.tax_id ? renderTaxDrawerContent() : renderDrawerContent()}
          </div>
        )}
      </Drawer>
      <LicensorAddTaxDocumentModal
        visible={isTaxModalVisible}
        onCancel={() => {
          setIsTaxModalVisible(false);
          setSelectedTaxItem(null);
        }}
        onSuccess={() => {
          setIsTaxModalVisible(false);
          setSelectedTaxItem(null);
          refetchTaxData();
        }}
        editId={selectedTaxItem?.tax_id}
      />
      <LicensorAddEditInvoiceDrawer
        visible={isInvoiceDrawerVisible}
        onClose={() => {
          setIsInvoiceDrawerVisible(false);
          setSelectedInvoiceItem(null);
        }}
        onSuccess={handleInvoiceDrawerSuccess}
        editMode={invoiceDrawerMode === 'edit'}
        requestId={selectedInvoiceItem?.tracking_id}
      />
      <AddPaymentProofModal
        visible={isPaymentModalVisible}
        onCancel={() => {
          setIsPaymentModalVisible(false);
          setSelectedPaymentItem(null);
        }}
        onSuccess={handlePaymentProofSuccess}
        invoiceId={selectedPaymentItem?.tracking_id}
      />
      </Col>
    </div>
  );
};

export default PartnerInvoice;